var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var AbstractNetwork = require('./../abstract/abstract-network'); // const lremove = require('lodash/remove');


var Cyclon = require('./cyclon/cyclon');

var lmerge = require('lodash.merge');
/**
 * CyclonAdapter adapts the usage of a Cyclon RPS in the foglet library.
 * @extends AbstractNetwork
 * @author Grall Arnaud (Folkvir)
 */


var CyclonAdapter =
/*#__PURE__*/
function (_AbstractNetwork) {
  "use strict";

  _inherits(CyclonAdapter, _AbstractNetwork);

  function CyclonAdapter(options) {
    _classCallCheck(this, CyclonAdapter);

    return _possibleConstructorReturn(this, _getPrototypeOf(CyclonAdapter).call(this, lmerge({
      webrtc: {
        // add WebRTC options
        trickle: true,
        // enable trickle (divide offers in multiple small offers sent by pieces)
        config: {
          iceServers: [] // define iceServers in non local instance

        }
      },
      origins: '*'
    }, options)));
  }
  /**
   * Build a Spray RPS
   * @param {Object} options - Options used to build the RPS
   * @return {Spray} The Spray network
   */


  _createClass(CyclonAdapter, [{
    key: "_buildRPS",
    value: function _buildRPS(options) {
      // if webrtc options specified: create object config for Spray
      var cyclonOptions = lmerge({
        config: options.webrtc
      }, options);
      return new Cyclon(cyclonOptions);
    }
    /**
     * The in-view ID of the peer in the network
     * @return {string} The in-view ID of the peer
     */

  }, {
    key: "getReachableNeighbours",

    /**
     * Get the IDs of all available neighbours with or without their suffix -I or -O
     * @param  {Boolean} transform - transform IDs into reachable ids to used for send messages => (peer) => peer-O
     * @return {String[]} Set of IDs for all available neighbours
     */
    value: function getReachableNeighbours() {
      var transform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return this._rps.uniqNeighbours(transform);
    }
    /**
     * Get the IDs of all available neighbours with or without their suffix -I or -O
     * @param  {Integer} limit - Max number of neighbours to look for
     * @return {String[]} Set of IDs for all available neighbours
     */

  }, {
    key: "getNeighbours",
    value: function getNeighbours() {
      var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      return this._rps.getPeers(limit);
    }
    /**
     * Get the IDs of all available neighbours
     * @return {String[]} Set of IDs for all available neighbours
     */

  }, {
    key: "getArcs",
    value: function getArcs() {
      var arcs = this._rps.neighbours();

      var i = arcs.inview.map(function (entry) {
        return entry.peer;
      });
      var o = arcs.inview.map(function (entry) {
        return entry.peer;
      });
      return i.concat(o);
    }
  }, {
    key: "inviewId",
    get: function get() {
      return this._rps.getInviewId();
    }
    /**
     * The out-view ID of the peer in the network
     * @return {string} The out-view ID of the peer
     */

  }, {
    key: "outviewId",
    get: function get() {
      return this._rps.getOutviewId();
    }
  }]);

  return CyclonAdapter;
}(AbstractNetwork);

module.exports = CyclonAdapter;